<template>
  <a-select v-model="value" @change="handleChange" :dropdownStyle="{ 'text-align': 'left' }">
    <a-select-option v-for="item in locales" :key="item.value" :value="item.value">
      <div style="display: flex;align-items: center;line-height: 1;">
        <Emoji :data="emojiIndex" :emoji="item.emoji" set="twitter" :size="18" />
        <span>{{ item.label }}</span>
      </div>
    </a-select-option>
  </a-select>
</template>

<script>
import { locales, setLocale } from '@/locales/i18n'
import emojiData from "emoji-mart-vue-fast/data/twitter.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Emoji, EmojiIndex } from "emoji-mart-vue-fast";
let emojiIndex = new EmojiIndex(emojiData)

export default {
  components: {
    Emoji
  },
  data() {
    return {
      emojiIndex,
      value: window.localStorage.getItem("locale"),
      locales,
    };
  },
  methods: {
    handleChange(value) {
      setLocale(value)
    },
  },
};
</script>
